import { VALIDATION_ENUM } from "enums";
import { Field, Form, Formik } from "formik";
import { useSendContactMessage } from "hooks/contact";
import { useRef } from "react";
import { Button, Checkbox, Input, Textarea } from "shared";
import { ROUTE_ENUM } from "enums";
import * as Yup from "yup";

type ContactFormProps = {};

const ContactForm: React.FC<ContactFormProps> = () => {
  const { mutateAsync: sendMessage } = useSendContactMessage();
  const formRef = useRef<any>(null);
  const onSubmit = (values: any) => {
    sendMessage(values, {
      onSuccess: () => {
        formRef.current.resetForm();
      },
    });
  };
  const initialValues = {
    name: "",
    email: "",
    message: "",
    acceptance: false,
    rodo: false,
  };

  const validation = () =>
    Yup.object().shape({
      name: Yup.string()
        .required(VALIDATION_ENUM.REQUIRED)
        .matches(
          /^[^\s].*?[^\s]$/,
          VALIDATION_ENUM.CANNOT_START_AND_END_WITH_SPACE
        ),
      email: Yup.string()
        .email(VALIDATION_ENUM.WRONG_EMAIL)
        .required(VALIDATION_ENUM.REQUIRED)
        .matches(
          /^[a-zA-Z0-9_%+-]+([.][a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          VALIDATION_ENUM.WRONG_EMAIL
        ),
      message: Yup.string().required(VALIDATION_ENUM.REQUIRED),
      acceptance: Yup.boolean().oneOf([true], VALIDATION_ENUM.REQUIRED),
      rodo: Yup.boolean().oneOf([true], VALIDATION_ENUM.REQUIRED),
    });
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values: any) => onSubmit(values)}
      validationSchema={validation()}
      enableReinitialize
      innerRef={formRef}
    >
      {({ errors, values, handleSubmit }) => (
        <Form className="contact__form">
          <h3>Formularz kontaktowy</h3>
          <div className="contact__form-row">
            <Field
              type="text"
              id="name"
              name="name"
              label={"Imię"}
              as={Input}
            />
            <Field
              type="email"
              id="email"
              name="email"
              label={"Email"}
              as={Input}
            />
          </div>

          <Field
            type="textarea"
            id="message"
            name="message"
            label={"Wiadomość"}
            component={Textarea}
            maxLength={1000}
          />
          <Field
            id="acceptance"
            name="acceptance"
            wrapperClassName="login-wrapper__acceptance"
            label={
              <p>
                Zgadzam się na warunki umieszczone w{" "}
                <a
                  className="bold"
                  href={ROUTE_ENUM.TERMS_OF_SERVICE}
                  target="_blank"
                  rel="noreferrer"
                >
                  regulaminie aplikacji{" "}
                </a>
                i{" "}
                <a
                  className="bold"
                  href={ROUTE_ENUM.PRIVACY_POLICY}
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  polityce prywatności.
                </a>
              </p>
            }
            as={Checkbox}
          />
          <Field
            id="rodo"
            name="rodo"
            wrapperClassName="login-wrapper__rodo"
            label={
              <p>
                Akceptuję warunki{" "}
                <a
                  className="login-wrapper__rodo"
                  href={ROUTE_ENUM.RODO}
                  target="_blank"
                  rel="noreferrer"
                >
                  Klauzuli RODO
                </a>
              </p>
            }
            as={Checkbox}
          />
          <Button
            label={"Wyślij"}
            type="submit"
            styleType="primary"
            size="large"
            onClick={() => null}
          />
        </Form>
      )}
    </Formik>
  );
};

export default ContactForm;
